import React, {useState} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import {notify} from "../../utils/notify";

const useStyles = makeStyles(theme => ({
    evenSmaller: {
        fontSize: '100%',
        '& .MuiSvgIcon-root': {
            fontSize: '100%',
        }
    },
    skinny: {
        minWidth: 24,
    }
}));

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})(props => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles(theme => ({
    root: {
        paddingTop: 0,
        paddingBottom: 0,
    },
}))(MenuItem);

const ItemMenu = (props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-label="note menu"
                color="inherit"
                variant="contained"
                size="small"
                className={classes.evenSmaller}
                onClick={handleMenuClick}
            >
                <MoreVertIcon/>
            </IconButton>
            <StyledMenu
                id="item-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <StyledMenuItem>
                    <ListItemIcon className={classes.skinny}>
                        <DeleteOutlineIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText primary="Delete" onClick={() => {
                        props.itemDelete({
                            variables: {
                                deleteNoteId: props.itemId,
                            }
                        }).then(() => {
                            handleMenuClose();
                            props.itemsRefetch();
                        }).catch((e) => {
                            notify('deleteNote', 'error', e.message);
                        });
                    }}/>
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default ItemMenu;
